export default "__VITE_ASSET__b70777ab__"